import { render, staticRenderFns } from "./StarRatingExecute.vue?vue&type=template&id=63974237&scoped=true"
import script from "./StarRatingExecute.vue?vue&type=script&lang=js"
export * from "./StarRatingExecute.vue?vue&type=script&lang=js"
import style0 from "./StarRatingExecute.vue?vue&type=style&index=0&id=63974237&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63974237",
  null
  
)

export default component.exports